import { all, fork } from 'redux-saga/effects';
import { watchUsers } from './modules/users/sagas';
import { watchUsage } from './modules/usage/sagas';
import { watchOrganization } from './modules/organization/sagas';
import { watchApp } from './modules/app/sagas';
import { watchBilling } from './modules/billing/sagas';
import { watchProfile } from './modules/profile/sagas';
import { watchVetting } from './modules/vetting/sagas';
import { watchSignUp } from './modules/signup/sagas';
import { watchLogin } from './modules/login/sagas';
import { watchPasswordReset } from './modules/passwordReset/sagas';

export default function* watch() {
  yield all([fork(watchUsers)]);
  yield all([fork(watchUsage)]);
  yield all([fork(watchOrganization)]);
  yield all([fork(watchApp)]);
  yield all([fork(watchBilling)]);
  yield all([fork(watchProfile)]);
  yield all([fork(watchVetting)]);
  yield all([fork(watchSignUp)]);
  yield all([fork(watchLogin)]);
  yield all([fork(watchPasswordReset)]);
}
